// extracted by mini-css-extract-plugin
export default {"footer":"SiteFooter_footer__huUjj","bottom":"SiteFooter_bottom__LdrOg"};